import * as Segment from '@hotjar/webapp/domains/common/tracking/segment';

import { extractSiteGroupingProps } from '../utils';
import type { TrackingSite } from '../utils';

interface ItemSharedArgs {
  item?: string;
  recordingId?: number;
  relevanceScore?: number;
  sharedStatus?: 'On' | 'Off';
}

/**
 * @deprecated Please import this function from `@hotjar/tracking`.
 * Track when a user shares an item.
 */
export const itemShared = (
  { item, recordingId, relevanceScore, sharedStatus }: ItemSharedArgs,
  site: TrackingSite,
): Promise<void> => {
  const groupData = extractSiteGroupingProps(site) || {};

  const trackData = {
    ...(item && { item }),
    ...(recordingId && { recording_id: recordingId }),
    ...(relevanceScore && { relevance_score: relevanceScore }),
    ...(sharedStatus && { shared_status: sharedStatus }),
    ...groupData,
  };

  return Segment.track('Item Shared', trackData);
};
